import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPreviewOffFilledStyle0 = cosmosIconCss;

const CosmosIconPreviewOffFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPreviewOffFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '290cb59763f08cd84978d8d1314b9869a94e498b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '33b20282c15a4e854e0a78237fc2ff505db14814', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b06cfd858bb6d1e3c13603f1c28223a14b9dffd2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.515 3.146a.512.512 0 0 1 .717 0l3.48 3.48A8.117 8.117 0 0 1 10.886 6c3.32 0 5.86 1.83 7.82 4.71a.55.55 0 0 1 0 .58c-.884 1.336-1.912 2.441-3.086 3.244l3.233 3.233a.522.522 0 0 1 0 .727l-.359.359a.522.522 0 0 1-.727 0L3.147 4.233a.512.512 0 0 1 0-.718l.368-.369Zm9.253 8.536a2 2 0 0 0-2.562-2.562l2.562 2.562Zm-9.682-.972c.632-.932 1.324-1.755 2.084-2.44l7.536 7.537a8.474 8.474 0 0 1-1.82.193c-3.31 0-5.88-1.81-7.8-4.71a.53.53 0 0 1 0-.58Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPreviewOffFilledStyle0; }
}, [1, "cosmos-icon-preview-off-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-preview-off-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-preview-off-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPreviewOffFilled$1);
            }
            break;
    } });
}

const CosmosIconPreviewOffFilled = CosmosIconPreviewOffFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPreviewOffFilled, defineCustomElement };
